import { Accordion, Button, Card } from "react-bootstrap";
import { FaPlus } from "react-icons/fa6";

const CardLayout = ({
  children,
  addButtonHandler,
  title,
  buttonTitle,
  searchComponent,
  selectedComponent,
}) => (
  <Card className="border p-3 rounded">
    <Card.Body>
      <div className="card-box d-flex justify-content-between align-items-center">
        <Card.Title className="mb-0 text-uppercase">{title}</Card.Title>
        {buttonTitle && (
          <div className="">
            <Button onClick={addButtonHandler}>
              <FaPlus /> {buttonTitle}
            </Button>
          </div>
        )}
      </div>
      <hr />
      {searchComponent && (
        <>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="1">
              <Accordion.Header>Search</Accordion.Header>
              <Accordion.Body>
                <div>{searchComponent}</div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <hr />
        </>
      )}

      {selectedComponent && selectedComponent}

      {children}
    </Card.Body>
  </Card>
);

export default CardLayout;
